import { toast, ToastOptions, TypeOptions } from "react-toastify";

// Define ToastType as an enum
export enum ToastType {
  SUCCESS = "success",
  ERROR = "error",
  WARN = "warn",
  INFO = "info",
}

const colors: Record<ToastType, { background: string; color: string }> = {
  [ToastType.SUCCESS]: { background: "green", color: "white" },
  [ToastType.ERROR]: { background: "red", color: "white" },
  [ToastType.WARN]: { background: "yellow", color: "black" },
  [ToastType.INFO]: { background: "blue", color: "white" },
};

export const showToast = (
  message: string,
  type: ToastType = ToastType.SUCCESS,
  duration = 3000
): void => {
  const style = {
    backgroundColor: colors[type].background,
    color: colors[type].color,
  };

  const options: ToastOptions = {
    type: type as TypeOptions,
    autoClose: duration,
    style,
    position: "bottom-center",
  };

  toast(message, options);
};
